<template>
  <ion-page>
    <!-- <ion-header> -->
    <div class="overlay" v-if="currentTab !== 'match-detail'">
      <ion-toolbar class='header-bar'>
        <ion-buttons slot="start">
          <div class="pl-05 pointer" @click="openMenu()">
            <ion-icon :icon="menuSharp" />
          </div>
        </ion-buttons>
        <ion-title size="medium">{{appTitle}}</ion-title>
      </ion-toolbar>
    </div>
    <div class="overlay" v-if="!compListOpen && ['schedule', 'ladder', 'leaderboard'].includes(currentTab)">
      <ion-item class="pl-10">
        <ion-label>Season</ion-label>
        <ion-select placeholder="Select One" v-model="filterSeason">
          <ion-select-option v-for="season in seasons" :key="season._id" :value="season._id">{{ season._id }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item class="pl-10" v-if="currentTab === 'schedule'">
        <ion-label>Type</ion-label>
        <ion-select placeholder="Select One" v-model="gameType">
          <ion-select-option v-for="type in gameTypes" :key="type.type" :value="type.type">{{ type.name }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-toolbar>
        <ion-buttons slot="start" class="pl-05 pointer">
          <ion-icon :icon="caretDownOutline" @click="compListOpen = true"/>
        </ion-buttons>
        <ion-grid :scroll-x="true" class="competition-row ml-10" :style="{'white-space': 'nowrap', 'padding-top': '1rem', 'background': $background ? $background + ' !important' : '#222'}" nowrap>
          <ion-chip v-for="{_id, name} in sortedCompetitions" :id="`competition-${_id}`" :key="_id" @click="competitionId = _id" :class="{
            'mr-10': true,
            chip: true,
            active: competitionId === _id,
            selectable: competitionId !== _id
          }">
            <ion-label>{{ name }}</ion-label>
          </ion-chip>
        </ion-grid>
      </ion-toolbar>
      <template v-if="currentTab === 'schedule' && displayMatches === true">
        <ion-grid v-if="availableRounds.length" :scroll-x="true" class="date-row d-flex" :style="{'align-items': 'center', 'white-space': 'nowrap', 'padding-top': '1rem', 'background': $background ? $background + ' !important' : '#222'}" nowrap>
          <div :class="{
            'mr-30': true,
            dateOption: true,
            active: round === false,
            selectable: round !== false
          }" @click="round = false">
            <!-- <span> {{ roundFilter }} </span> -->
            <span class="format"> ALL ROUNDS </span>
          </div>
            <div v-for="{format, round: roundNumber } in sortBy(availableRounds, 'round')" :key="format" :class="{
              'mr-30': true,
              dateOption: true,
              active: round === roundNumber,
              selectable: round !== roundNumber
            }" @click="round = roundNumber">
              <!-- <span> {{ roundNumber }} </span> -->
              <span v-if="Number.isInteger(roundNumber)" class="format"> {{ format }} </span>
              <span v-else class="format"> {{ format }} </span>
            </div>
        </ion-grid>
      </template>
      <ion-toolbar v-if="competition.hasPools">
        <ion-grid :scroll-x="true" class="competition-row ml-10" :style="{'white-space': 'nowrap', 'padding-top': '1rem', 'background': $background ? $background + ' !important' : '#222'}" nowrap>
          <ion-chip
            @click="selectedPool = null"
            :class="{
              'mr-10': true,
              chip: true,
              active: selectedPool === null,
              selectable: selectedPool !== null
            }">
            <ion-label>All Pools</ion-label>
          </ion-chip>
          <ion-chip
            v-for="pool in pools"
            :key="pool.name"
            @click="selectedPool = pool"
            :class="{
              'mr-10': true,
              chip: true,
              active: selectedPool?.name === pool.name,
              selectable: selectedPool?.name !== pool.name
            }">
            <ion-label>{{ pool.name }}</ion-label>
          </ion-chip>
        </ion-grid>
      </ion-toolbar>
    </div>
    <!-- </ion-header> -->
    <ion-content class="" v-if="!compListOpen && !loading">
      <div class="mt-20" v-if="currentTab === 'explore' ">
        <explore />
      </div>
      <div v-if="currentTab === 'schedule'" class="mt-20">
        <div v-if="filteredMatches.length && displayMatches === true">
          <template v-for="({ round, matches, format }) in groupedMatches" :key="round">
            <div>
              <ion-text v-if="Number.isInteger(round)"> <h4 class="round-text f-bold" > {{ format }} </h4> </ion-text>
              <ion-text v-else> <h4 class="round-text f-bold" > {{ format }} </h4> </ion-text>
              <template v-for="(match) in matches" :key="match._id">
                <div class="competition-section-desktop">
                  <match-card-desktop :match="match" />
                </div>
                <div class="competition-section">
                  <MatchCard :match="match" :competitionId="+get(match, 'competition._id')"  />
                </div>
              </template>
              <template v-for="(match) in matches" :key="match._id">
                <ion-card class="bye-card" v-if="match && (match.round.type.toLowerCase() == 'regular' || match.round.type.toLowerCase() == 'knockout') && getByes(match.round).length && match.lastMatchOfRound === true">
                  <ion-card-content>
                    <ion-text> <h4 class="round-text f-bold" > Round {{ match.round.number }} BYES </h4> </ion-text>
                    <ion-slides pager="true" :options="slideOpts">
                      <ion-slide v-for="({team}, idx) in getByes(match.round)" :key="idx">
                        <div class="flex flex-column align-center">
                          <TeamLogoOpacity :team="team"/>
                          <div class="team-name light-text text-center mt-10">{{get(team, 'name', 'N/A')}}</div>
                        </div>
                      </ion-slide>
                    </ion-slides>
                  </ion-card-content>
                </ion-card>
              </template>
            </div>
          </template>
        </div>
        <div v-else-if="displayMatches === false" class="empty-container" >
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder text-center">Matches Result Not Available to Public</h1>
            </ion-text>
          </ion-card>
        </div>
        <div v-else class="empty-container" >
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">No Matches Available</h1>
            </ion-text>
          </ion-card>
        </div>
      </div>
      <div v-if="currentTab === 'ladder'" class="flex flex-column justify-center" style="width:100%;">
        <Ladder v-if="ladder.competition" :key="key" :ladder="ladder" :selectedPool="selectedPool" />
        <div v-else-if="displayLadders === false" class="empty-container" >
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">Ladders Not Available to Public</h1>
            </ion-text>
          </ion-card>
        </div>
        <div v-else class="empty-container" >
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">No Ladder Available</h1>
            </ion-text>
          </ion-card>
        </div>
      </div>
      <div v-if="currentTab === 'leaderboard'" class="flex flex-column justify-center" style="width:100%;">
        <ion-item class="mt-20 pl-10" lines="none">
          <ion-select v-model="eventType" interface="popover">
            <ion-select-option v-for="type in scoringTypes" :key="type.type" :value="type.type">{{`${type.name}s`}}</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-text v-if="eventLadder.competition"> <h4 class="round-text f-bold" > {{ eventLadder.competition.name }} </h4> </ion-text>
        <ScoringLadder :key="key" :eventLadder="eventLadder" :eventType="find(scoringTypes, type => type.type === +eventType)"/>
        <div class="empty-container" v-if="!eventLadder">
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">No Leaderboard Available</h1>
            </ion-text>
          </ion-card>
        </div>
      </div>
    </ion-content>

    <ion-content v-else-if="!loading">
      <ion-text><h1 class="round-text text-center">COMPETITIONS</h1></ion-text>
      <ion-list>
        <ion-item v-for="{_id, name} in sortedCompetitions" :key="_id" @click="competitionId = _id; compListOpen = false" >
          <ion-label>{{ name }}</ion-label>
          <!-- tick if selected -->
          <ion-checkbox slot="end" v-if="competitionId === _id" checked="true"></ion-checkbox>
        </ion-item>
      </ion-list>

    </ion-content>

    <ion-content v-else>
      <Skeleton />
    </ion-content>

  </ion-page>
</template>

<script>
import { ellipsisVertical, personCircle, flagOutline, podiumOutline,arrowBackOutline,arrowForwardOutline, caretDownOutline, menuSharp} from "ionicons/icons";
import { loadingController, menuController } from "@ionic/vue";
import Ladder from '../../components/Ladder';
import ScoringLadder from '../../components/ScoringLadder';
import Explore from '../Explore.vue'
import Skeleton from '../../components/Skeleton';
import TeamLogo from './base/team-logo.vue';
import TeamLogoOpacity from './base/team-logo-opacity.vue';
import MatchCard from '../../components/MatchCard.vue';
import MatchCardDesktop from '../../components/MatchCardDesktop.vue';
import {weatherCodes} from '@/utils/constants';
const Timer = require('@/utils/timer');
import { mapGetters } from "vuex";
import _ from 'lodash';
import moment from 'moment-timezone';
import {
  getCurrentInstance,
} from 'vue';

const fetchWeather = async (matches) => {
  const baseUrl = 'https://api.tomorrow.io/v4/timelines?';

  const weatherData = []; // rego _id, data
  for (const match of matches) {
    const address = _.get(match, 'venue.address');
    const startDate = _.get(match, 'dateTime');

    const weather = weatherData.find((w) => w._id === match._id);
    if (!address || !startDate) {
      match.weather = {};
    } else if (weather) {
      match.weather = weather.data;
    } else {
      const { lat, lng } = address;
      const query = {
        location: [lat, lng],
        fields: ['weatherCode', 'temperature'],
        timesteps: '1d',
        units: 'metric',
        apikey: process.env.VUE_APP_WEATHER_API_KEY,
        startTime: moment(startDate).startOf('day').toISOString(),
        endTime: moment(startDate).add(2, 'days').toISOString()
      };
      const queryString = new URLSearchParams(query).toString();
      const url = `${baseUrl}${queryString}`;
      // eslint-disable-next-line no-await-in-loop
      await fetch(url).then((r) => r.json()).then((res) => {
        const wData = _.get(res, 'data.timelines[0].intervals[1].values', {});
        // const wData = {
        //   weatherCode: 1000,
        //   temperature: 20.44
        // };
        if (wData.weatherCode) {
          wData.base = _.find(weatherCodes, (c) => c.value === wData.weatherCode) || {};
        }
        weatherData.push({ _id: match._id, data: wData });
        match.weather = wData;
      }).catch(() => {
        match.weather = {};
      });
    }
  }
  // return matches;
};

export default {
  components: {
    TeamLogo,
    TeamLogoOpacity,
    MatchCard,
    MatchCardDesktop,
    Ladder,
    ScoringLadder,
    Skeleton,
    Explore,
  },
  props: {
    entityLevel: String,
    entityName: String,
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      caretDownOutline,
      menuSharp
    }
  },
  data() {
    const { filter } = this.$store.state.matches;
    let season = 2025;
    // if (+process.env.VUE_APP_NATIONAL_ID === 7) {
    //   season = 2024;
    // }
    return {
      sortBy: _.sortBy,
      slideOpts: {
        initialSlide: 1,
        speed: 400,
        navigation: false,
        pagination: false,
        centerInsufficientSlides: true,
        // slidesPerView: 4,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 5,
            spaceBetween: 40
          }
        }
      },
      compListOpen: false,
      dateFilter: false,
      upperCase: _.upperCase,
      get: _.get,
      find: _.find,
      ellipsisVertical,
      personCircle,
      filterSeason: season,
      competitionId: null,
      competition: {},
      round: filter.round,
      team: filter.team,
      matches: [],
      byes:[],
      ladder: {},
      eventLadder: [],
      filter,
      key: 0,
      loading: true,
      segment: 'matches',
      ladderSegment: 'ladderBoard',
      eventType: {},
      displayMatches: true,
      displayLadders: true,
      timers: [],
      pusher: {},
      scoringEventTypes: [],
      isEmpty: _.isEmpty,
      selectedPool: null,
      currentTab: '',
      gameTypes: [
        { type: 'all', name: 'All' },
        { type: 'teams', name: 'Teams' },
        { type: 'indv', name: 'Individual' },
      ],
      gameType: 'all',
    };
  },
  updated() {
    // const uiCompId = this.$store.getters['ui/competitionId'];
    // if (uiCompId) {
    //   this.competitionId = uiCompId;
    // }
    // const uiSeason = this.$store.getters['ui/season'];
    // if (uiSeason) {
    //   this.filterSeason = uiSeason;
    // }
  },
  async beforeMount() {
    console.log('----------- beforeMount ------------');
    try {
      // If there's a forceReload query param, clean it up before proceeding
      if (this.$route.query.forceReload) {
        console.log('Found forceReload query param, cleaning up');
        this.$router.replace({
          path: this.$route.path,
          query: {}
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }

      const path = this.$route.path;
      if (path.includes('/ladders')) {
        this.currentTab = 'ladder';
      } else if (path.includes('/leaderboard')) {
        this.currentTab = 'leaderboard';
      } else if (path.includes('/schedule')) {
        this.currentTab = 'schedule';
      }else{
        this.currentTab = this.$store.getters['matches/currentTab'];
      }

      const compId = this.$store.getters['matches/getCompetitionId'];
      console.log({
        compId
      });
      if (compId) {
        this.competitionId = compId;
      }
      console.log({
        competitionId: this.competitionId
      });

      if(this.scoringTypes && this.scoringTypes.length > 0) {
        console.log('---- beforeMount: this.scoringTypes ----');
        this.eventType = this.scoringTypes[0].type;
      }
      await this.customArrange();

      // Check for entity mismatch that might need to be addressed
      if (window.innerWidth < 768 &&
          this.entity &&
          this.$route.params.entityName &&
          this.entity.name !== this.$route.params.entityName) {
        console.log('Entity mismatch detected during mount, forcing reload');
        this.forceReload();
      }
    } catch (error) {
      console.log(error);
    }
    // loadingController
    //   .create({ message: "Loading competitions..." })
    //   .then(loading => {
    //     loading.present();
    //   });
  },
  mounted() {
    console.log('----------- mounted ------------');
    if (this.competitionId) {
      this.fetchCompetitionData(this.competitionId);
    }
    // if (+process.env.VUE_APP_NATIONAL_ID === 7) {
    //   this.filterSeason = 2024;
    // }

    // Add timeout to ensure data is loaded before scrolling
    setTimeout(() => {
      this.scrollToMostRecentRound();
    }, 1000);
  },
  computed: {
    ...mapGetters('national', ['timezone']),
    scoringTypes() {
      let types = [];
      const competition = _.find(this.competitions, (c) => c._id === this.competitionId);
      const isCustom = _.get(competition, 'isCustom', false);
      if (competition) {
        const useCustomScoringEvents = _.get(competition, 'competitionSettings.useCustomScoringEvents', undefined);
        const nationalScoringEvents = _.get(competition, 'competitionSettings.nationalScoringEvents', []);
        const scoringEvents = isCustom 
          ? _.get(competition, 'scoringEvents', [])
          : _.get(competition, 'competitionSettings.scoringEvents', [])
        const filteredMatches = _.filter(this.$store.state.national.scoringEvents, (st) => _.includes(nationalScoringEvents, st.type));
        const scoringResult = useCustomScoringEvents ? _.concat(scoringEvents, filteredMatches) : scoringEvents;
        if (!useCustomScoringEvents || (!scoringResult || scoringResult.length < 1)) {
          types = scoringResult && scoringResult.length ? scoringResult :  this.$store.state.national.scoringEvents;
        }
        console.log({ scoringEvents: scoringResult})
        types = scoringResult;
      }

      console.log({ scoringEvents: this.$store.state.national.scoringEvents})
      types = this.$store.state.national.scoringEvents;
      return types.filter(type => type.name);
    },
    pools() {
      const { competition } = this;
      return _.get(competition, 'pools', []);
    },
    // scoringTypes(){
    //   const types = this.$store.state.national.scoringEvents;
    //   return _.filter(types, (type) => type.visibleInLadders !== false);
    // },
    appTitle() {
      const meta = this.$store.getters['national/getMeta'];
      console.log('meta at scheduler', meta);
      if (meta && meta.name) return meta.name;
      return process.env.VUE_APP_BANNER_TITLE;
    },
    seasons(){
      const seasons =  this.$store.state.national.seasons;
      return seasons.sort((a, b) => b._id - a._id);
    },
    entity() {
      return this.$store.getters['national/getEntity'];
    },
    rounds(){
      return _.uniq(_.map(this.matches, 'round.displayName'));
    },
    teams() {
      return _.uniq([_.map(this.matches, 'homeTeam.name'), _.map(this.matches, 'awayTeam.name')].flat());
    },
    sortedCompetitions() {
      const { competitions, key } = this;
      return _.orderBy(this.competitions, ['order'], ['asc']);
    },
    availableDates() {
      // get match.dateTime and group by dates, return array of dates
      const { matches } = this;
      const dates = _.map(matches, (match) => {
        return {
          format: moment(match.dateTime).format('DD MMM').toUpperCase(),
          dayOfWeek: // return day of week if not today, otherwise return today
            moment(match.dateTime).format('DD MMM') !== moment().format('DD MMM')
              ? moment(match.dateTime).format('ddd').toUpperCase()
              : 'Today'
        }
      })
      // filter duplicate formats
      return dates.filter((date, index) => {
        return dates.findIndex((d) => d.format === date.format) === index;
      });
    },
    availableRounds() {
      // get match.round and group by rounds, return array of rounds
      const matches = this.matches;
      matches.forEach((item) => {
        if (item.round.type.toLowerCase() == 'regular') {
          item.round.arrange = item.round.number;
        } else if (item.round.type.toLowerCase() == 'final') {
          item.round.arrange = item.round.displayName;
        } else if (item.round.type.toLowerCase() == 'knockout') {
          item.round.arrange = item.round.number;
        }
      });
      // const nowTime = Date.now();
      // const matchesInThePresentAndFuture = _.orderBy(_.filter(matches, (m) => nowTime <= m.dateTime), 'dateTime', 'asc');
      // const matchesInThePast = _.orderBy(_.filter(matches, (m) => nowTime > m.dateTime), 'dateTime', 'desc');
      // const roundsPresentAndFuture = _.groupBy(matchesInThePresentAndFuture, 'round.arrange');
      // const roundsPast = _.groupBy(matchesInThePast, 'round.arrange');
      // const combinedMatches = [...matchesInThePresentAndFuture, ...matchesInThePast];
      const regularRounds = _.filter(matches, (m) => m.round.type === 'Regular');
      const finalRounds = _.filter(matches, (m) => m.round.type === 'Final');
      const knockoutRounds = _.filter(matches, (m) => m.round.type === 'Knockout');
      const mappedRoundNumbers = _.map(regularRounds, 'round.number');
      const uniqueRoundNumbers = _.uniq(mappedRoundNumbers);
      const lastRegularRoundNumber = _.max(uniqueRoundNumbers);
      regularRounds.forEach((item) => {
        item.round.arrange = item.round.number;
      });
      finalRounds.forEach((item) => {
        item.round.arrange = item.round.number + lastRegularRoundNumber;
      });
      knockoutRounds.forEach((item) => {
        item.round.arrange = item.round.number + (lastRegularRoundNumber || 0);
      });
      const orderedRegularRounds = _.orderBy(regularRounds, 'round.number', 'desc');
      const orderedFinalRounds = _.orderBy(finalRounds, 'round.number', 'desc');
      const orderedKnockoutRounds = _.orderBy(knockoutRounds, 'round.number', 'desc');
      const combinedMatches = [...orderedRegularRounds, ...orderedFinalRounds, ...orderedKnockoutRounds];
      const groupedCombinedMatches = _.groupBy(combinedMatches, 'round.arrange');
      const combinedRounds = _.sortBy(groupedCombinedMatches, group => combinedMatches.indexOf(group[0]));
      const rounds = Object.keys(combinedRounds).map(key => ({
        round: _.get(combinedRounds[key][0], 'round.arrange'),
        format: _.get(combinedRounds[key][0], 'round.displayName'),
        dateTime: _.get(combinedRounds[key][0], 'dateTime', 0),
      }));

      // filter duplicate formats
      return rounds.filter((round, index) => {
        return rounds.findIndex((r) => r.format === round.format) === index;
      });
    },
    filteredMatches() {
      let matches = Object.assign([], this.matches).sort((a, b) => {
        return b.round.number - a.round.number || (b.round.type === 'Final' ? 1 : -1);
      });

      if (this.selectedPool) {
        const poolTeamIds = this.selectedPool.teams.map(team => team._id);
        matches = matches.filter(match =>
          (match.homeTeam && poolTeamIds.includes(match.homeTeam._id)) ||
          (match.awayTeam && poolTeamIds.includes(match.awayTeam._id))
        );
      }

      const regularR = matches.filter(m => m.round.type === 'Regular');
      const finalR = matches.filter(m => m.round.type === 'Final');
      const knockoutR = matches.filter(m => m.round.type === 'Knockout');

      const uniqueRoundNumbers = [...new Set(regularR.map(m => m.round.number))];
      const lastRegularRoundNumber = Math.max(...uniqueRoundNumbers, 0);

      const regularRounds = regularR.map(r => r.round
        ? { ...r, round: { ...r.round, arrange: r.round.number } }
        : { ...r, round: { arrange: r.round.number } });
      const finalRounds = finalR.map(r => r.round
        ? { ...r, round: { ...r.round, arrange: r.round.number + lastRegularRoundNumber } }
        : { ...r, round: { arrange: r.round.number + lastRegularRoundNumber, matches: [] } });
      const knockoutRounds = knockoutR.map(r => r.round
        ? { ...r, round: { ...r.round, arrange: r.round.number + lastRegularRoundNumber } }
        : { ...r, round: { arrange: r.round.number + lastRegularRoundNumber, matches: [] } });

      const allRounds = [...regularRounds, ...finalRounds, ...knockoutRounds];
      const roundFiltered = !this.round ? matches : allRounds.filter(m => m.round.arrange === this.round);
      const nextRoundFiltered = !this.round ? this.matches : this.matches.filter(m => m.round.number === this.round + 1);
      const isComplete = roundFiltered.every(rnd => rnd.status === 'final');

      const teamFiltered = !this.team
        ? roundFiltered
        : roundFiltered.filter(m => (m.homeTeam && m.homeTeam.name === this.team) || (m.awayTeam && m.awayTeam.name === this.team));

      const rounds = [...new Set(teamFiltered.map(m => m.round.number))];
      const lastMatch = rounds.map((round) => {
        const roundMatches = teamFiltered.filter(m => m.round.number === round);
        roundMatches[roundMatches.length - 1] = {
          ...roundMatches[roundMatches.length - 1],
          lastMatchOfRound: true,
        }
        return roundMatches;
      }).flat();

      const filteredMatches = lastMatch.sort((a, b) => {
        return (b.round.type === 'Final' ? 1 : -1) || b.round.number - a.round.number;
      });

      const uniqFilteredMatches = Array.from(new Map(filteredMatches.map(match => [match['_id'], match])).values());
      return uniqFilteredMatches;
    },
    groupedMatches() {
      const matches = this.filteredMatches;
      const regularRounds = _.filter(matches, (m) => m.round.type === 'Regular');
      const finalRounds = _.filter(matches, (m) => m.round.type === 'Final');
      const knockoutRounds = _.filter(matches, (m) => m.round.type === 'Knockout');

      // Get unique round numbers and find the last regular round number
      const mappedRoundNumbers = _.map(regularRounds, 'round.number');
      const uniqueRoundNumbers = _.uniq(mappedRoundNumbers);
      const lastRegularRoundNumber = _.max(uniqueRoundNumbers) || 0;

      // Set arrange property for sorting
      regularRounds.forEach((item) => {
        item.round.arrange = item.round.number;
      });

      finalRounds.forEach((item) => {
        item.round.arrange = item.round.number + lastRegularRoundNumber;
      });

      knockoutRounds.forEach((item) => {
        item.round.arrange = item.round.number + lastRegularRoundNumber;
      });

      // Combine all matches and remove duplicates
      const combinedMatches = [...regularRounds, ...finalRounds, ...knockoutRounds]
        .filter((match, index, array) =>
          array.findIndex(m => m._id === match._id) === index
        );

      // Group matches by round.arrange
      const groupedByRound = _.groupBy(combinedMatches, 'round.arrange');

      // Convert to array and add earliest match date for each round
      const groupedRounds = Object.keys(groupedByRound).map(key => {
        const roundMatches = groupedByRound[key];
        // Find earliest match date in this round for temporal relevance
        const earliestMatch = _.minBy(roundMatches, 'dateTime');

        return {
          round: _.get(roundMatches[0], 'round.arrange'),
          dateTime: _.get(earliestMatch, 'dateTime', 0),
          matches: roundMatches,
          format: _.get(roundMatches[0], 'round.displayName')
        };
      });

      // Sort by round number incrementally
      return _.sortBy(groupedRounds, 'round');
    }
  },
  methods: {
    matchIsVs(match) {
      return _.get(match, 'competitionSettings.type') === 'vs';
    },
    async getEventTypes() {
      try {
        const compId = this.competitionId;
        const resEvents = await this.$http.get(`assemble/api/v1/live/competitions/${compId}/events`);
        this.scoringEventTypes = _.get(resEvents, 'data.data.scoringEvents', []);
        if (this.scoringEventTypes.length > 0) {
          this.eventType = this.scoringEventTypes[0].type;
        }
      } catch (error) {
        console.log('There was an error fetching event types', error);
      }
    },
    forceReload() {
      // This method can be called to force a hard reload when needed on mobile devices
      if (this.$route.query.forceReload) {
        return; // Prevent infinite reloads
      }

      // Add a timestamp query param to force fresh data load
      const timestamp = Date.now();
      const query = { ...this.$route.query, forceReload: timestamp };

      console.log('Forcing page reload to refresh data');
      this.$router.replace({
        path: this.$route.path,
        query
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    scrollToActiveElement() {
      const gridContainer = document && document.querySelector('.competition-row');
      const activeElement = gridContainer ? gridContainer.querySelector('.active') : false;

      if (activeElement) {
        gridContainer.scrollTop = activeElement.offsetTop;
        gridContainer.scrollLeft = activeElement.offsetLeft - 50;
      }
    },
    getMatchDate(dateTime) {
      return moment(dateTime).tz(this.timezone).format('LLL')
    },
    customArrange() {
      const nationalId = process.env.VUE_APP_NATIONAL_ID;
      const {competitions, seasons} = this;
      const currentSeason = _.find(seasons, {'currentSeason': true});
      let arrangementName = [];
      let arrangementId = [];
      let arranged = [];
      if (competitions && nationalId === "8") {
        if (_.get(currentSeason, '_id') === 2022) {
          // arrangementName = [
          //   'Superliga e Meshkujve',
          //   'Superliga e Femrave',
          //   'Liga e ParÃ« Meshkujt',
          //   'Liga e ParÃ« Femrat',
          //   'Liga e KadetÃ«ve (M)',
          //   'Liga e Kadeteve (F)',
          //   'Liga e FatosÃ«ve',
          //   'Liga e Fatoseve',
          //   'Kupa e KosovÃ«s (M)',
          //   'Kupa e KosovÃ«s (F)',
          // ];
          arrangementId = [
            300140,
            300141,
            300124,
            300125,
            300138,
            300130,
            300131,
            300128,
            300129,
            300135,
            300136,
            300133,
            300134,
          ];
          arrangementId.forEach((item, i) => {
            const comp = _.find(competitions, (c) => c._id === item);
            if (!comp) {
              return
            }
            arranged.push(comp);
          });
          const compNotInList = _.filter(competitions, (c) => !arrangementId.includes(c._id));
          compNotInList.forEach((item, i) => {
            arranged.push(item);
          });
          this.competitions = arranged;
          const foundPublic = this.competitions.find((c) => c.display && c.display.public && c.display.result)
          this.competitionId = foundPublic ? foundPublic._id : _.get(this.competitions[0], '_id');
        }
      }
      this.key++;
    },
    openMenu() {
      // menuController.enable(true, 'side');
      menuController.open('side');
    },
    checkForfeit(type,status,meta,team){
      if(type === 'homeTeam'){
        if(status === 'forfeit'){
          const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
          return isForfeitingTeam ? true: false;
        }
        return false;
      }else if( type === 'awayTeam'){
        if(status === 'forfeit') {
          const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
          return isForfeitingTeam ? true: false;
        }
        return false;
      }
    },
    getHomeScore(scores,status,meta,homeTeam){
      if(status === 'forfeit'){
        const competition = _.find(this.competitions, { _id: this.competitionId });
        const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(homeTeam, 'name');
        return isForfeitingTeam ? 0 : _.get(competition, 'laddertemplate.defaultScoreFFReceived');
      }
      else{
        return _.get(scores, 'homeTeam', 0);
      }
    },
    getAwayScore(scores,status,meta,awayTeam){
      if(status === 'forfeit'){
        const competition = _.find(this.competitions, { _id: this.competitionId });
        const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(awayTeam, 'name');
        return isForfeitingTeam ? 0 : _.get(competition, 'laddertemplate.defaultScoreFFReceived');
      }
      else{
        return _.get(scores, 'awayTeam', 0);
      }
    },
    // isLastIndex(round, index, groupMatchIndex) {
    //   const nextIndex = index+1;
    //   if(!this.groupedMatches[groupMatchIndex].matches[nextIndex]) return true;
    //   return round.number !== this.groupedMatches[groupMatchIndex].matches[nextIndex].round.number;
    // },
    getByes(round) {
      const res = _.filter(this.byes, g=> g.round.number === round.number);
      return res;
    },
    // getWeatherIcon(name) {
    //   var images = require.context('../assets/weather-icons/', false, /\.svg$/)
    //   return images('./' + name + ".svg")
    // },
    goMatch(id) {
      if(this.entity && this.entityLevel && this.entityName){
        this.$router.push(`/c/${this.entityLevel}/${this.entityName}/matches/${id}`);
        return;
      }
      this.$router.push(`/matches/${id}`);
    },
    goToAS() {
      window.open('https://assemblesports.com', "_blank");
    },
    randomizeAds() {
      const freq = 5;
      const rand =  Math.random();
      return rand  <= (freq / 100);
    },
    // segmentChanged(event) {
    //   this.segment = event.detail.value;
    //   if(this.segment === 'matches'){
    //     this.ladderSegment = 'ladderBoard';
    //   }else{
    //     this.ladderSegment = 'ladderBoard';
    //   }
    // },
    // ladderSegmentChanged(event) {
    //   this.ladderSegment = event.detail.value;
    // },
    // setSegment(){
    //   if (this.filteredMatches.length > 0) this.segment = 'matches';
    //   else if(Object.keys(this.ladder).length > 0) this.segment = 'ladder';
    //   else this.segment = 'matches';
    // },
    gameStatusColor(status) {
      switch (status) {
      case 'pre-game':
        return 'dark';
      case 'final':
        return 'success';
      case 'forfeit':
      case 'washout':
        return 'warning';
      case 'disputed':
      case 'offline':
        return 'danger';
      case 'first-half':
      case 'second-half':
        return 'light';
      default:
        return 'light';
      }
    },
    scrollToMostRecentRound() {
      if (!this.groupedMatches || !this.groupedMatches.length) return;

      // Find the most recent round with matches that have already started or are about to start
      const now = Date.now();
      const recentRounds = [...this.groupedMatches].sort((a, b) => {
        // Find the closest match date to now (prioritizing future matches that are closest)
        const aTimeDiff = Math.abs(a.dateTime - now);
        const bTimeDiff = Math.abs(b.dateTime - now);
        return aTimeDiff - bTimeDiff;
      });

      if (recentRounds.length) {
        const targetRound = recentRounds[0];

        // Use nextTick to ensure DOM is updated before trying to scroll
        this.$nextTick(() => {
          // Find all round headers
          const allRoundHeaders = document.querySelectorAll('h4.round-text');
          let targetElement = null;

          // Loop through all headers to find the one matching our target format
          for (let i = 0; i < allRoundHeaders.length; i++) {
            if (allRoundHeaders[i].textContent.trim() === targetRound.format) {
              targetElement = allRoundHeaders[i];
              break;
            }
          }

          // If found, scroll to it
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    },
    async fetchCompetitionData(competitionId, oldCompetitionId) {
      console.log('Fetching competition data');
      console.log({
        competitionId,
        oldCompetitionId,
        currentTab: this.currentTab,
        entity: this.entity,
        isMobile: window.innerWidth < 768
      });

      if (!competitionId) return;

      try {
        // Always show loading when changing competitions
        this.loading = true;

        // On mobile devices, check if we've transitioned to a different entity
        if (window.innerWidth < 768 &&
            this.entity &&
            this.$route.params.entityName &&
            this.entity.name !== this.$route.params.entityName &&
            !this.$route.query.forceReload) {
          console.log('Entity mismatch detected on mobile device, forcing reload');
          this.forceReload();
          return;
        }

        if (this.currentTab === 'schedule') {
          // Always reset display flags when changing competitions
          this.displayMatches = true;

          let res = {};

          try {
            res = await this.$http.get(`assemble/api/v1/live/matches/competitions/${competitionId}`);
          } catch (e) {
            console.log('error fetching matches', e);
            this.displayMatches = false;
            this.loading = false;
            throw 'An error with getting the competitions has occurred';
          }

          // Update displays and data based on API response
          this.displayMatches = res.data.data.displays.result;
          this.displayLadders = res.data.data.displays.ladder;
          this.competition = res.data.data.competition;

          const { matches, byes } = res.data.data;
          this.matches = matches;
          this.byes = byes;

          this.$store.commit('matches/setCompetitionId', competitionId);
          const foundComp = _.find(this.competitions, { _id: competitionId });
          this.$store.commit('matches/setLaddertemplate', foundComp ? foundComp.laddertemplate : null);
        }

        // Fetch additional data based on current tab
        if (this.currentTab === 'ladder') {
          const resLadder = await this.$httpNoAuth.get(`/assemble/api/v1/live/ladders/competition/${competitionId}`);
          this.ladder = Object.assign({}, resLadder.data.data);
        } else if (this.currentTab === 'leaderboard' && this.eventType) {
          const resEventLadder = await this.$httpNoAuth.get(
            `/assemble/api/v1/live/leaderboard/competition/${competitionId}`,
            { params: { eventType: this.eventType } }
          );
          this.eventLadder = resEventLadder.data.data;
        }

        this.key++;

        // Use $nextTick to ensure DOM is updated before scrolling
        this.$nextTick(() => {
          // Give a small delay to ensure rendering is complete
          setTimeout(() => {
            this.scrollToMostRecentRound();
          }, 100);
        });
      } catch (error) {
        console.error('Error fetching competition data:', error);
      } finally {
        this.loading = false;
        this.$forceUpdate();
      }
    },
  },
  watch: {
    // Add a watch for route changes to detect navigation between different club URLs
    $route: {
      immediate: true,
      async handler(newRoute, oldRoute) {
        // Handle the forceReload query parameter if present
        if (newRoute.query.forceReload && !oldRoute?.query.forceReload) {
          console.log('Force reload detected, resetting data');
          this.loading = true;

          await this.$nextTick();
          await this.customArrange();

          this.loading = false;
          return;
        }

        // Check if navigation is between different entities
        if (oldRoute &&
            (newRoute.params.entityName !== oldRoute.params.entityName ||
             newRoute.params.entityLevel !== oldRoute.params.entityLevel)) {
          console.log('Route changed between entities, refreshing data');
          this.loading = true;

          // Wait for the next tick to ensure entity data is available
          await this.$nextTick();

          // Set current tab based on route
          const path = this.$route.path;
          if (path.includes('/ladders')) {
            this.currentTab = 'ladder';
          } else if (path.includes('/leaderboard')) {
            this.currentTab = 'leaderboard';
          } else if (path.includes('/schedule')) {
            this.currentTab = 'schedule';
          } else {
            this.currentTab = this.$store.getters['matches/currentTab'];
          }

          // Reset data and fetch competition data
          this.compListOpen = false;
          this.competitionId = null;
          this.competition = {};
          this.matches = [];
          this.byes = [];
          this.ladder = {};
          this.eventLadder = [];
          this.displayMatches = true;
          this.displayLadders = true;

          // Wait for entity data to be available
          await this.$nextTick();
          await this.customArrange();

          // On mobile devices, we might need to force a hard reload
          // Check if we're on a mobile device by looking at screen width
          if (window.innerWidth < 768 &&
              !newRoute.query.forceReload &&
              newRoute.params.entityName !== oldRoute.params.entityName) {
            setTimeout(() => {
              // Delay the force reload to allow the initial navigation to complete
              this.forceReload();
            }, 100);
          }

          this.loading = false;
        }
      }
    },
    "$store.state.national.seasons": {
      handler: function(seasons) {
        if (seasons && seasons.length > 0) {
          // First check if there's a stored season in Vuex
          const storedSeason = this.$store.getters['ui/season'];

          if (storedSeason) {
            // If there's a stored season, use that
            this.filterSeason = storedSeason;
          } else {
            // Otherwise use the default logic
            if (+process.env.VUE_APP_NATIONAL_ID === 17 || +process.env.VUE_APP_NATIONAL_ID === 21) {
              this.filterSeason = 2025;
            } else {
              this.filterSeason = seasons.find(season => season.currentSeason)._id;
            }
          }
        }
      },
      immediate: true,
    },
    round(name) {
      this.$store.commit('matches/setRound', name);
    },
    team(name) {
      this.$store.commit('matches/setTeam', name)
    },
    filterSeason: {
      async handler(id) {
        if (!id) return;

        try {
          this.loading = true;

          // Reset competition data
          this.competitionId = undefined;
          this.competition = {};
          this.matches = [];
          this.byes = [];
          this.ladder = {};
          this.eventLadder = [];

          // Store selected season in Vuex
          this.$store.dispatch('ui/updateSeason', { season: id });

          // Fetch competitions for season
          let resComp;
          if (this.entity && this.entity._id) {
            resComp = await this.$http.get("assemble/api/v1/live/competitions", {
              params: {
                season: id,
                entityType: this.entity.level,
                entityId: this.entity._id,
                gameType: this.gameType
              }
            });
          } else {
            resComp = await this.$http.get("assemble/api/v1/live/competitions", {
              params: {
                season: id,
                gameType: this.gameType
              }
            });
          }

          this.competitions = resComp.data.data;

          // Set competition ID
          if (this.competitions.length) {
            const foundPublic = this.competitions.find(c => c.display?.public && c.display?.result);
            this.competitionId = foundPublic ? foundPublic._id : _.get(this.competitions[0], '_id');
          }

          if (this.scoringTypes?.length > 0) {
            console.log('---- setting event type ----');
            this.eventType = this.scoringTypes[0].type;
          }

          this.customArrange();
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },
      immediate: true
    },
    gameType: {
      immediate: true,
      async handler(newGameType) {
        if (!newGameType) return;

        try {
          this.loading = true;

          // Reset competition data
          this.competitionId = undefined;
          this.competition = {};
          this.matches = [];
          this.byes = [];
          this.ladder = {};
          this.eventLadder = [];

          // Fetch competitions for the new game type
          let resComp;
          if (this.entity && this.entity._id) {
            resComp = await this.$http.get("assemble/api/v1/live/competitions", {
              params: {
                season: this.filterSeason,
                entityType: this.entity.level,
                entityId: this.entity._id,
                gameType: this.gameType
              }
            });
          } else {
            resComp = await this.$http.get("assemble/api/v1/live/competitions", {
              params: {
                season: this.filterSeason,
                gameType: this.gameType
              }
            });
          }

          this.competitions = resComp.data.data;

          // Set competition ID
          if (this.competitions.length) {
            const foundPublic = this.competitions.find(c => c.display?.public && c.display?.result);
            this.competitionId = foundPublic ? foundPublic._id : _.get(this.competitions[0], '_id');
          }

          if (this.scoringTypes?.length > 0) {
            console.log('---- setting event type ----');
            this.eventType = this.scoringTypes[0].type;
          }

          await this.customArrange();
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    eventType: {
      // immediate: true,
      async handler(eventType){
        if (this.currentTab !== 'leaderboard') return;
        this.loading = true;
        try {
          if(eventType){
            this.eventLadder = [];
            const resEventLadder = await this.$httpNoAuth.get(`/assemble/api/v1/live/leaderboard/competition/${this.competitionId}`, { params: { eventType: eventType } })
            this.eventLadder = resEventLadder.data.data;
            this.key++;
            this.loading = false;
          }
        } catch (error) {
          console.log(error);
        }
        finally {
          this.loading = false;
        }

      }
    },
    competitionId: {
      async handler(id, oldId) {
        if (!id) return;

        try {
          console.log('Competition ID changed:', id, 'from', oldId);

          // Prevent duplicate fetches when tab is ladder
          if (this.currentTab !== 'ladder') {
            await this.fetchCompetitionData(id, oldId);
          } else {
            this.ladder = {};
            this.loading = true;
            const resLadder = await this.$httpNoAuth.get(`/assemble/api/v1/live/ladders/competition/${id}`);
            this.ladder = Object.assign({}, resLadder.data.data);
            this.loading = false;
          }

          this.$store.dispatch('ui/updateCompetitionId', { competitionId: id });
          this.scrollToActiveElement();
          this.getEventTypes();
        } catch (error) {
          console.error('Error fetching competition data:', error);
          this.loading = false;
        }
      }
    },
    currentTab: {
      immediate: true,
      deep: true,
      handler(newTab, oldTab) {
        console.log('newTab', newTab);

        // Only run this logic when actually changing tabs (not on initial load)
        if (oldTab && newTab !== oldTab) {
          // Get the current season from store before any updates happen
          const storedSeason = this.$store.getters['ui/season'];
          console.log('storedSeason', storedSeason);

          // Store the current season in a local variable to prevent it from being overwritten
          const currentSeason = storedSeason || this.filterSeason;

          // Use nextTick to ensure this runs after Vue has processed other updates
          this.$nextTick(() => {
            if (currentSeason && currentSeason !== this.filterSeason) {
              this.filterSeason = currentSeason;
            }

            // If needed, fetch data based on the current tab
            if (this.competitionId) {
              this.fetchCompetitionData(this.competitionId);
            }
          });
        }
      }
    },
    entity: {
      immediate: true,
      deep: true,
      async handler(newEntity, oldEntity) {
        if (newEntity && (!oldEntity || newEntity._id !== oldEntity._id)) {
          console.log('Entity changed, refreshing competitions data');
          this.loading = true;

          // Reset data
          this.compListOpen = false;
          this.competition = {};
          this.matches = [];
          this.byes = [];
          this.ladder = {};
          this.eventLadder = [];

          // Wait for next tick to ensure entity data is available
          await this.$nextTick();

          if (this.currentTab === 'schedule') {
            // Fetch competitions for the new entity
            try {
              const resComp = await this.$http.get("assemble/api/v1/live/competitions", {
                params: {
                  season: this.filterSeason,
                  entityType: newEntity.level,
                  entityId: newEntity._id,
                  gameType: this.gameType
                }
              });

              this.competitions = resComp.data.data;
              if (this.competitions.length > 0) {
                const foundPublic = this.competitions.find(c => c.display?.public && c.display?.result);
                this.competitionId = foundPublic ? foundPublic._id : _.get(this.competitions[0], '_id');
              }

              await this.customArrange();
            } catch (error) {
              console.log('Error fetching competitions:', error);
            }
          }

          this.loading = false;
        }
      }
    },
  }
};
</script>
<style scoped lang="scss">

ion-title {
  font-family: 'Cairo';
}

ion-grid {
  white-space: nowrap;
   --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

.header-bar {
  padding: 0.5rem;
}

.round-text {
  color: #fff;
  font-family: 'Cairo';
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
  // text-decoration: underline;
  // text-decoration-color: $highlight;
}

.competition-section-desktop {
    display: grid;
    grid-template-columns: 1fr;
    // padding: 1rem 1.5rem;
    @media screen and (max-width: 1080px) {
      display: none;
    }
  }
  .competition-section {
    display: grid;
    grid-template-columns: 1fr;

    @media screen and (min-width: 1080px) {
      display: none;
    }

    // on larger screen make it bigger
    @media only screen and (min-width: 768px) {
    //   grid-template-columns: repeat(auto-fit, minmax(40rem, 1fr));
      padding: 0.75rem;
    }
    // gap: 0.5rem;
    // padding: 1rem 1rem;
    .competition-option {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #17181B;
      border-radius: 1rem;
      // padding: 1rem 1rem;
    }
  }

.competition-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  background: $background !important;
}

.date-row {
  align-items: center;
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  padding: 1rem 1.5rem;
  background: $background !important;
  border-bottom: 1px solid #3a3a3a;
}

.chip {
  font-size: 1rem;
  color: #a9a9a9;
  font-family: 'Cairo';
  &.active {
    background: #4CAF50;
    color: white;
    // color: var(--ion-color-primary);
    font-family: 'Cairo';
  }

  &.selectable {
    cursor: pointer;
    color: #a9a9a9;
    background: #1E1F22;
  }
}



.dateOption {
  display: flex;
  flex-direction: column;
  align-items: center;
  // gap: 0.25rem;
  span {
    color: #a9a9a9;
    font-size: 0.8rem;
    font-family: 'Cairo';
    transition: all 0.2s ease-in-out;
  }

  .date {
    font-size: 1rem;
  }

  &.active {
    // background: white;
    // color: var(--ion-color-primary);
    span {
      // font-size: 0.9rem;
      color: white !important;
      font-family: 'Cairo';
    }
  }

  &.selectable {
    cursor: pointer;
    color: #fff;
    // background: #1E1F22;
  }
}

.display-round-byes {
  font-size: 10px;
  color: rgba(255,196, 37, .9);
  padding: 5px;
  position: absolute;
  top: -30px;
  left: 20px;
  background: #1e1f22;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.display-round {
  font-size: 10px;
  color: rgba(255,196, 37, .9);
  padding: 5px;
  position: absolute;
  top: -32px;
  left: 40px;
  background: #1e1f22;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}
.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
// .light-text {
//   font-size: 14px;
//   font-weight: 400;
//   text-transform: capitalize;
// }
// .normal-text {
//   font-size: 15px;
//   font-weight: 600;
//   text-transform: capitalize;
// }
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  /* color: rgba(8, 48, 109, 0.5); */
  color: white;
}

.header {
  --background: #1a2933 !important;
  color: white;
}

.custom-segment {
  background: $background !important;
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .segment-button-checked {
  color: $primary;
  --indicator-box-shadow: none;
  border-bottom: 2px solid $primary;
}

.bye-card {
  margin-inline: 1.5rem;
  position: relative;
  border-radius: 24px;
  cursor: pointer;
  // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);

  font-family: 'BrownStd-Regular';
  color: white;
   box-shadow: none;
  background: #171717 !important;
  .round-text {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}
.custom-card {
  border-radius: 24px;
  cursor: pointer;
  // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  font-family: 'BrownStd-Regular';
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
  // background: transparent;
   box-shadow: none;
  background: #171717 !important;
  margin-inline: 1.5rem;

  .venue {
    letter-spacing: -0.01rem;
  }
}
.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}

ion-item {
  --background: #232528;
  --color: white;
}

.custom-segment ion-label {
  margin-bottom: 0;
}

ion-content {
  background: $background;
  --background: $background;
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
}

ion-content::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: rgba(0,0,0,0.3);
}

ion-content::-webkit-scrollbar
{
  width: .35rem;
  background-color: rgba(0,0,0,0.3);
}

@media only screen and (max-width: 768px) {
  ion-content::-webkit-scrollbar {
    width: .15rem;
    background-color: rgba(0,0,0,0.3);
  }
}

ion-content::-webkit-scrollbar-thumb
{
  background-color: #888;
}


.overlay {
  background: $background;
  // background: $primary;
  padding: 0rem;
}

ion-toolbar, ion-item {
  --border-width: 0 !important;
  --background: $background;
  --color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

.custom-segment {
  border: none;
  /* background: white; */
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 177, 177, 0.3);
  padding-top: 1rem;
  border: none;
  background: none;
   display: flex;
  // justify-content: center;
  /* border-radius: 1rem !important; */
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .in-segment {
  color: rgba(177, 177, 177, 1);
  font-size: 1.3rem;
  // background-color: rgba($primary, .7);
}

.custom-segment .segment-button-checked {
  color: rgb(234 68 68);
  border-radius: 0;
  margin-bottom: 0;
  // background-color: rgba($primary, .7);
  color: $highlight;
  font-size: 1.3rem;
  font-weight: 500;
  --indicator-height: 0;
  --indicator-box-shadow: none;
  /* --indicator-color: rgb(234, 68, 68, 0.7);
  --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
  border-bottom: 3px solid $highlight;
}
.custom-segment-ladder {
  // border: none;
  margin: 0 auto;
  margin-top: 1rem;
  display: flex;
  width:70%;
  justify-content: center;
  border-radius: 0.6rem !important;
}

.custom-segment-ladder-button{
  flex-basis: 50%;
}


.custom-segment-ladder ::before {
  border-left: none;
}

.custom-segment-ladder .in-segment {
  color: rgba(177, 177, 177, 1);
  background-color: rgba($primary, .2);
}

.custom-segment-ladder .segment-button-checked {
  color: rgb(234 68 68);
  // margin-bottom: 0;
  background-color: rgba($primary, .7);
  color: $highlight;
  font-weight: 400;
  // --indicator-height: 0;
  // --indicator-box-shadow: none;
  //  --indicator-color: rgb(234, 68, 68, 0.7);
  // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1);
  // border-bottom: 3px solid $highlight;
}

.empty-container {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-container ion-card {
  padding: 4rem;
  border-radius: 1rem;
  background: transparent;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-placeholder {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

.team-name {
  font-size: 0.8rem;
  white-space: break-spaces;
}

ion-select::part(icon) {
  margin-left: 0.5rem;
  color: white !important;
  opacity: 0.85;
}

.elapseTime {
  font-size: 1.5rem;
}
</style>